import React, { ReactElement } from 'react';
import AddSubjektBezPripomienokComponent from './component/AddSubjektBezPripomienokComponent';
import ConfirmAction from '../ConfirmAction/ConfirmAction';

const AddSubjektBezPripomienokAdmin = (): ReactElement => (
  <>
    <ConfirmAction />
    <AddSubjektBezPripomienokComponent />
  </>
);

export default AddSubjektBezPripomienokAdmin;
